import { useState } from 'react';

import InfoIcon from '@/shared-components/icons/components/public/InfoIcon';
import XIcon from '@/shared-components/icons/components/public/XIcon';
import Text from '@/shared-components/text/components/Text';

import './styles/RatingInfoButton.css';

export default function RatingInfoButton({ category, text }) {
  const [openInfo, setOpenInfo] = useState(false);

  return (
    <>
      <button
        type="button"
        className="artwork-rate-category__info-trigger"
        onClick={() => setOpenInfo(true)}
        aria-label={`${category} info`}
        aria-expanded={openInfo}
        aria-haspopup="dialog"
      >
        <InfoIcon className="artwork-rate-category__info-icon" />
      </button>

      {openInfo && (
        <div
          className="artwork-rate-category__info-popup-overlay"
          role="dialog"
          aria-modal="true"
          aria-label={category}
          onClick={() => setOpenInfo(false)}
        >
          <div
            className="artwork-rate-category__info-popup"
            onClick={(event) => event.stopPropagation()}
          >
            <div className="artwork-rate-category__info-popup-header">
              <Text className="artwork-rate-category__info-popup-title font-size-medium">
                {category}
              </Text>

              <button
                type="button"
                className="artwork-rate-category__info-popup-close"
                onClick={() => setOpenInfo(false)}
                aria-label="Close info"
              >
                <XIcon className="artwork-rate-category__info-popup-close-icon" />
              </button>
            </div>

            <Text
              className="artwork-rate-category__info-popup-text font-size-small"
              paragraph
            >
              {text}
            </Text>
          </div>
        </div>
      )}
    </>
  );
}
